import { MenuItems } from '../types/MenuItems';

export const SIX_IN_TIX_LIST = [
  MenuItems.DASHBOARD,
  MenuItems.SHOP,
  MenuItems.SETTINGS,
  MenuItems.MARKETING,
  MenuItems.STATISTICS,
  MenuItems.FINANCE,
];
